import axios from '@/axios-mock'

module.exports = {
  member: () => {
    return axios({
      url: `/app/member`
    })
  }
}



// WEBPACK FOOTER //
// ./static/plugins/login/api.js